import type { UserPublic } from '@/client/types.gen';

/**
 * @see https://umijs.org/docs/max/access#access
 * 权限控制模块
 *
 * 这个函数定义了应用中所有的权限规则
 * initialState 是从 app.tsx 的 getInitialState 函数返回的全局状态
 *
 * 权限使用方式：
 * 1. 在路由配置中使用 access 属性，如 access: 'canAdmin'
 * 2. 在组件中使用 useAccess() hook 获取权限对象
 */
export default function access(
  initialState:
    | { currentUser?: UserPublic }
    | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser?.is_superuser,
  };
}
